import { ApiClient } from '@/services/apiClient';
import { getEnvVariable } from '@/utils/get-env-variable';

export const pciApiClient = new ApiClient(
  getEnvVariable('VITE_PCI_API_URL', 'https://payments-pci-gateway-staging.dev.appcharge-int.com')
);
